/* /pages/how-to-read-a-coa — scroll reveal + sticky bar */
(function () {
  'use strict';

  // Opt into the reveal animation only when JS is wired up. Until this class
  // is added, all [data-reveal] elements are visible by default (failsafe).
  var pageEl = document.querySelector('.htrcoa-page');
  if (pageEl) pageEl.classList.add('htrcoa-js-ready');

  // Scroll-reveal animation + animate range dots and bar fills
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('visible');
      e.target.querySelectorAll('.replica-iv-dot, .replica-hm-bar-fill').forEach(function (el) {
        var val = el.getAttribute('data-pos') || el.getAttribute('data-width');
        if (val === null) return;
        setTimeout(function () {
          if (el.classList.contains('replica-iv-dot')) el.style.left = val + '%';
          else el.style.width = val + '%';
        }, 200);
      });
      io.unobserve(e.target);
    });
  }, { threshold: 0.12 });
  document.querySelectorAll('.htrcoa-page [data-reveal]').forEach(function (el) { io.observe(el); });

  // FAQ a11y: mirror <details> open state to aria-expanded on the summary
  document.querySelectorAll('.htrcoa-page .faq-item').forEach(function (d) {
    var s = d.querySelector('.faq-summary');
    if (!s) return;
    s.setAttribute('aria-expanded', d.open ? 'true' : 'false');
    d.addEventListener('toggle', function () {
      s.setAttribute('aria-expanded', d.open ? 'true' : 'false');
    });
  });
})();
